import script from "./IndexBagian.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexBagian.vue?vue&type=script&setup=true&lang=js"

import "./IndexBagian.vue?vue&type=style&index=0&id=4c623b30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c623b30"]])

export default __exports__